import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";
import { MIRROR_PRIORITIES } from "store/modals/slice";

type Filter = {
  value: string | number;
  label: string;
};

interface Props {
  filterByTitle: string;
  onFilterSearchByTitle: (e: string) => void;
  handleApply: () => void;
  onFilterByDomain: (e: string) => void;
  filterByPriority: { value: string; label: string }[];
  onFilterByPriority: (e: { value: string; label: string }[]) => void;
  filterByDomain: string;
}
const MirrorFilter: React.FC<Props> = ({
  handleApply,
  onFilterSearchByTitle,
  onFilterByDomain,
  onFilterByPriority,
  filterByTitle,
  filterByDomain,
  filterByPriority,
}) => {
  const { t } = useTranslation();

  const handleApplyFilters = () => {
    handleApply();
  };

  const handleClearFilters = () => {
    onFilterByDomain("");
    onFilterSearchByTitle("");
    onFilterByPriority([]);
    handleApply();
  };

  return (
    <Filter
      className="mirror-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: filterByTitle,
          inputType: "string",
          setInputValue: onFilterSearchByTitle,
        },
        {
          type: FilterItemTypes.input,
          title: t("domain"),
          boxTitle: t("domain"),
          icon: gridIcon,
          inputValue: filterByDomain,
          inputType: "string",
          setInputValue: onFilterByDomain,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("priority"),
          boxTitle: t("priority"),
          icon: gridIcon,
          itemsArray: MIRROR_PRIORITIES.map((el) => ({
            label: t(el),
            value: el,
          })),
          activeItems: filterByPriority,
          handleApply: (v) =>
            onFilterByPriority(v as { value: string; label: string }[]),
        },
      ]}
    />
  );
};

export default MirrorFilter;
